import {
  AudioService,
  ApiResponse,
  TranscribeAudioRequest,
  TranscribeAudioResponse,
} from '../types';
import { BaseService } from '../base-service';

export class AudioServiceReal extends BaseService implements AudioService {
  constructor() {
    super('AudioService');
  }

  async transcribeAudio(
    request: TranscribeAudioRequest
  ): Promise<ApiResponse<TranscribeAudioResponse>> {
    this.log('transcribeAudio', { filename: request.audioFile.name, size: request.audioFile.size });

    // Create FormData for file upload
    const formData = new FormData();
    formData.append('audio_file', request.audioFile);

    return this.makeRequest<TranscribeAudioResponse>('/audio/transcribe', {
      method: 'POST',
      body: formData,
      // Don't set Content-Type header, let browser set it with boundary for FormData
    });
  }
}
